export default function isNumeric(input) {
    if (!input) return false

    const regex = new RegExp('^[0-9]*$', 'g')
    return regex.test(input)
}
